import { KboOutput } from "@models/configurators/configurator-di";
import { CToken } from "@models/configurators/ctoken";
import { KbObjectManager } from "@models/configurators/kb-object-manager";
import { FileOutput } from "@models/configurators/outputs/file-output";
import { IGlbOutput, IOutput } from "@models/entity-models";
import { eOutputType } from "@models/enums";

@KboOutput(CToken.GlbOutput, eOutputType.sceneModel)
export class glbOutput extends FileOutput implements IGlbOutput {
    constructor(kom: KbObjectManager, args?: IOutput) {
        super(kom, args);
        this.type = eOutputType.sceneModel;
    }

    public idScene: number;
}